// extracted by mini-css-extract-plugin
module.exports = {"title":"_7a3fb80146--title--mNStg","row":"_7a3fb80146--row--BSQ9s","key":"_7a3fb80146--key--unNVK","value":"_7a3fb80146--value--eDDWO","warning":"_7a3fb80146--warning--ADrBz"};